import React from 'react';

export default function Logo({ className, ...props }) {
  return (
    <div className={`logo ${className}`}>
      <img
        alt={props.alt}
        src={props.src}
      />
      {props.caption ? props.caption : null}
    </div>
  );
}

Logo.defaultProps = {
  // eslint-disable-next-line quotes
  src: '/loading.gif',
  alt: 'loading...',
};
